/**
 * React Query cache key constants
 *
 * @deprecated Import query keys from '@/lib/query-keys' instead.
 * These SCREAMING_CASE constants are re-exported from the centralized
 * query key factory for backwards compatibility.
 *
 * @example
 * // Preferred (new):
 * import { matterKeys, taskKeys, fileKeys } from '@/lib/query-keys';
 *
 * // Legacy (still works):
 * import { MATTER_KEYS, TASK_KEYS, FILE_KEYS } from '@/lib/constants';
 */

import {
  matterKeys,
  taskKeys,
  contactKeys,
  inventoryKeys,
  institutionKeys,
  correspondenceKeys,
  timelineKeys,
  accountKeys,
  notificationKeys,
  fileKeys,
  documentKeys
} from '@/lib/query-keys';

/**
 * @deprecated Use matterKeys from '@/lib/query-keys' instead
 */
export const MATTER_KEYS = matterKeys;

/**
 * @deprecated Use taskKeys from '@/lib/query-keys' instead
 */
export const TASK_KEYS = taskKeys;

/**
 * @deprecated Use documentKeys from '@/lib/query-keys' instead
 */
export const DOCUMENT_KEYS = documentKeys;

/**
 * @deprecated Use contactKeys from '@/lib/query-keys' instead
 */
export const CONTACT_KEYS = contactKeys;

/**
 * @deprecated Use inventoryKeys from '@/lib/query-keys' instead
 */
export const INVENTORY_KEYS = inventoryKeys;

/**
 * @deprecated Use institutionKeys from '@/lib/query-keys' instead
 */
export const INSTITUTION_KEYS = institutionKeys;

/**
 * @deprecated Use correspondenceKeys from '@/lib/query-keys' instead
 */
export const CORRESPONDENCE_KEYS = correspondenceKeys;

/**
 * @deprecated Use timelineKeys from '@/lib/query-keys' instead
 */
export const TIMELINE_KEYS = timelineKeys;

/**
 * @deprecated Use accountKeys from '@/lib/query-keys' instead
 */
export const ACCOUNT_KEYS = accountKeys;

/**
 * @deprecated Use notificationKeys from '@/lib/query-keys' instead
 */
export const NOTIFICATION_KEYS = notificationKeys;

/**
 * @deprecated Use fileKeys from '@/lib/query-keys' instead
 */
export const FILE_KEYS = fileKeys;

/** Export-related query keys */
export const EXPORT_KEYS = {
  all: ['exports'] as const,
  list: (matterId: number) => ['exports', 'list', matterId] as const,
  status: (matterId: number, exportId: number) =>
    ['exports', 'status', matterId, exportId] as const
} as const;

/** Correspondence export-related query keys */
export const CORRESPONDENCE_EXPORT_KEYS = {
  all: ['correspondence-exports'] as const,
  list: (matterId: number, correspondenceId: number) =>
    ['correspondence-exports', 'list', matterId, correspondenceId] as const,
  status: (matterId: number, correspondenceId: number, exportId: number) =>
    [
      'correspondence-exports',
      'status',
      matterId,
      correspondenceId,
      exportId
    ] as const
} as const;
